export default class {
    id = null;
    parentId = null;
    name = "";
    value = "";
    phone = "";
    order = 0;

    constructor(data = {}) {
        for (let key in this) {
            if (data[key] !== undefined) {
                if (data[key] !== 'null') {
                    this[key] = data[key];
                } else {
                    this[key] = '';
                }
            }
            if (key === 'phone') {
              this[key] = this[key] && parseInt(this[key].replace(/\D+/g,"")).toString()
            }
        }
    }

    getDataToSave() {
        let data = {};
        for (let key in this) {
            if (this[key] === undefined || this[key] === null) {
                if (['parentId', 'id'].indexOf(key) !== -1) {
                    // data[key] = null;
                } else {
                    data[key] = 'null';
                }
            } else if (this[key] === '') {
                data[key] = 'null';
            } else {
                data[key] = this[key];
            }
        }
        return data;
    }
}
